/*
	Asset: qb-nuancier.js — QB Wuré
	Script de la section QB - Nuancier (sections/qb-nuancier.liquid), sorti du Liquid le
	28/09/2026 : 16,8 Ko servis en ligne dépassaient le budget de 16 Ko, et un asset est mis en
	cache d'une fiche produit à l'autre. Chargé en defer par la section : il s'exécute une fois
	le document lu et monte tous les nuanciers présents. Le contrat, les états et les pièges sont
	décrits dans l'en-tête de la section.
*/
(function () {
	if (!window.__qbNuancier) {
		var OK_MS = 2200;

		function doux() {
			return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
		}

		function racineDe(el) {
			return el && el.closest ? el.closest('[data-qb-nuancier]') : null;
		}

		function piste(racine) {
			return racine.querySelector('[data-qb-nu-piste]');
		}

		function peindreDefilement(racine) {
			var p = piste(racine);
			if (!p) return;
			var max = p.scrollWidth - p.clientWidth;
			var part = p.scrollWidth > 0 ? Math.min(1, p.clientWidth / p.scrollWidth) : 1;
			var avance = max > 0 ? p.scrollLeft / max : 0;
			var jauge = racine.querySelector('[data-qb-nu-jauge]');
			if (jauge) jauge.style.transform = 'translateX(' + (avance * (1 - part) * 100) + '%) scaleX(' + part + ')';
			racine.querySelectorAll('[data-qb-nu-pas]').forEach(function (b) {
				var bout = b.getAttribute('data-qb-nu-pas') === '-1' ? p.scrollLeft < 4 : p.scrollLeft >= max - 4;
				b.setAttribute('aria-disabled', bout ? 'true' : 'false');
			});
		}

		var glisse = null;

		function versPosition(g, x) {
			var max = g.p.scrollWidth - g.p.clientWidth;
			var course = g.largeur - g.pouce;
			if (course <= 0 || max <= 0) return;
			var r = (x - g.gauche - g.decalage) / course;
			g.p.scrollLeft = Math.max(0, Math.min(1, r)) * max;
		}

		function aimanter(p) {
			var max = p.scrollWidth - p.clientWidth;
			if (p.scrollLeft >= max - 2) return;
			var base = p.getBoundingClientRect().left + (parseFloat(getComputedStyle(p).paddingLeft) || 0);
			var mieux = null;
			p.querySelectorAll('[data-qb-nu-groupe]:not([hidden])').forEach(function (c) {
				var d = c.getBoundingClientRect().left - base;
				if (mieux === null || Math.abs(d) < Math.abs(mieux)) mieux = d;
			});
			if (mieux !== null && Math.abs(mieux) > 1) p.scrollTo({ left: p.scrollLeft + mieux, behavior: doux() });
		}

		function lacher(event) {
			if (!glisse || event.pointerId !== glisse.id) return;
			var g = glisse;
			glisse = null;
			g.zone.classList.remove('is-glisse');
			g.p.style.scrollSnapType = '';
			aimanter(g.p);
		}

		document.addEventListener('pointerdown', function (event) {
			var zone = event.target.closest && event.target.closest('[data-qb-nu-defil]');
			if (!zone || event.button > 0) return;
			var p = piste(racineDe(zone));
			if (p.scrollWidth <= p.clientWidth) return;
			var pouce = zone.querySelector('[data-qb-nu-jauge]').getBoundingClientRect();
			var ligne = zone.firstElementChild.getBoundingClientRect();
			var surPouce = event.clientX >= pouce.left && event.clientX <= pouce.right;
			glisse = {
				zone: zone,
				p: p,
				id: event.pointerId,
				gauche: ligne.left,
				largeur: ligne.width,
				pouce: pouce.width,
				decalage: surPouce ? event.clientX - pouce.left : pouce.width / 2
			};
			/* Sans aimantation pendant le geste, sinon le navigateur ramène la piste à chaque pas. */
			p.style.scrollSnapType = 'none';
			zone.classList.add('is-glisse');
			try { zone.setPointerCapture(event.pointerId); } catch (e) {}
			event.preventDefault();
			versPosition(glisse, event.clientX);
		});

		document.addEventListener('pointermove', function (event) {
			if (glisse && event.pointerId === glisse.id) versPosition(glisse, event.clientX);
		});

		document.addEventListener('pointerup', lacher);
		document.addEventListener('pointercancel', lacher);

		/* Table id → [valeur, disponible, prix, nom complet, options], seulement sur un produit à plusieurs options. */
		function variantes(racine) {
			if (racine._qbVariantes === undefined) {
				var el = racine.querySelector('[data-qb-nu-variantes]');
				try { racine._qbVariantes = el ? JSON.parse(el.textContent) : null; } catch (e) { racine._qbVariantes = null; }
			}
			return racine._qbVariantes;
		}

		/* Pack : disponibilité de chaque carte pour les autres options de la combinaison annoncée par la fiche. */
		function dispoCartes(racine, options) {
			var table = variantes(racine);
			if (!table || !options) return;
			var rang = Number(racine.getAttribute('data-option').replace('option', '')) - 1;
			var index = {};
			Object.keys(table).forEach(function (id) { if (table[id][4]) index[table[id][4].join('|')] = table[id]; });
			racine.querySelectorAll('[data-qb-nu-choix]').forEach(function (c) {
				var voulu = options.slice();
				voulu[rang] = c.getAttribute('data-valeur');
				var ligne = index[voulu.join('|')];
				var dispo = !!(ligne && ligne[1]);
				c.setAttribute('data-dispo', dispo ? 'true' : 'false');
				c.querySelectorAll('[data-qb-nu-epuisee]').forEach(function (m) { m.hidden = dispo; });
			});
		}

		function cartesVisibles(racine) {
			return Array.prototype.filter.call(racine.querySelectorAll('[data-qb-nu-choix]'), function (c) {
				return !c.closest('[data-qb-nu-groupe]').hidden;
			});
		}

		/* Un seul arrêt de Tab dans le groupe : la teinte choisie, ou la première visible si un filtre la cache. */
		function tabulation(racine) {
			var visibles = cartesVisibles(racine);
			var cible = visibles.filter(function (c) { return c.getAttribute('aria-checked') === 'true'; })[0] || visibles[0];
			racine.querySelectorAll('[data-qb-nu-choix]').forEach(function (c) {
				c.tabIndex = c === cible ? 0 : -1;
			});
		}

		/* Teinte épuisée : les teintes disponibles juste avant et juste après, dans l'ordre du clair au foncé. */
		function voisines(racine, choix, dispo) {
			var zone = racine.querySelector('[data-qb-nu-voisines]');
			if (!zone) return;
			zone.replaceChildren();
			zone.hidden = dispo;
			if (dispo) return;
			var toutes = Array.prototype.slice.call(racine.querySelectorAll('[data-qb-nu-choix]'));
			var i = toutes.indexOf(choix);
			var trouvees = [];
			for (var a = i - 1; a >= 0; a--) {
				if (toutes[a].getAttribute('data-dispo') === 'true') { trouvees.push(toutes[a]); break; }
			}
			for (var b = i + 1; b < toutes.length; b++) {
				if (toutes[b].getAttribute('data-dispo') === 'true') { trouvees.push(toutes[b]); break; }
			}
			if (!trouvees.length) {
				zone.textContent = 'Toutes les teintes sont épuisées pour le moment.';
				return;
			}
			zone.append(trouvees.length > 1 ? 'Disponibles juste à côté : ' : 'Disponible juste à côté : ');
			trouvees.forEach(function (c, n) {
				if (n) zone.append(', ');
				var lien = document.createElement('button');
				lien.type = 'button';
				lien.className = 'qb-nuancier__voisine';
				lien.setAttribute('data-qb-nu-voisine', c.getAttribute('data-id'));
				lien.textContent = c.getAttribute('data-valeur');
				zone.append(lien);
			});
		}

		/* v (facultatif) : la combinaison exacte annoncée par la fiche, qui prime sur celle de la carte. */
		function choisir(racine, choix, depuisFiche, v) {
			racine.querySelectorAll('[data-qb-nu-choix]').forEach(function (c) {
				c.setAttribute('aria-checked', c === choix ? 'true' : 'false');
			});
			var dispo = v ? v.dispo : choix.getAttribute('data-dispo') === 'true';
			var valeur = choix.getAttribute('data-valeur');
			var nom = (v && v.nom) || choix.getAttribute('data-nom') || valeur;
			racine.querySelector('[data-qb-nu-b-disque]').style.setProperty('--qb-nu-teinte', choix.style.getPropertyValue('--qb-nu-teinte'));
			racine.querySelector('[data-qb-nu-b-nom]').textContent = valeur;
			racine.querySelector('[data-qb-nu-b-info]').textContent = choix.getAttribute('data-info');
			racine.querySelector('[data-qb-nu-id]').value = v ? v.id : choix.getAttribute('data-id');
			var bouton = racine.querySelector('[data-qb-nu-ajout]');
			clearTimeout(bouton._qbOk);
			bouton._qbDispo = dispo;
			bouton.disabled = !dispo || bouton.getAttribute('aria-busy') === 'true';
			bouton.setAttribute('data-qb-nu-nom', nom);
			bouton.innerHTML = '';
			var lib = document.createElement('span');
			lib.setAttribute('data-qb-nu-b-lib', '');
			lib.textContent = dispo ? 'Ajouter ' + nom : 'Teinte épuisée';
			var prix = document.createElement('span');
			prix.textContent = v ? v.prix : choix.getAttribute('data-prix');
			bouton.appendChild(lib);
			bouton.appendChild(prix);
			racine.querySelector('[data-qb-nu-erreur]').textContent = '';
			voisines(racine, choix, dispo);
			tabulation(racine);
			if (depuisFiche) return;
			synchroniserFiche(racine, valeur);
		}

		function synchroniserFiche(racine, valeur) {
			var fiche = document.querySelector('section[data-section-type="product"][data-product-handle="' + racine.getAttribute('data-produit') + '"]');
			if (!fiche) return;
			var radios = fiche.querySelectorAll('input.radio-input[name="' + racine.getAttribute('data-option') + '"]');
			for (var i = 0; i < radios.length; i++) {
				if (radios[i].value === valeur) {
					if (!radios[i].checked) radios[i].click();
					break;
				}
			}
		}

		function montrer(racine, carte) {
			var p = piste(racine);
			var ecart = carte.getBoundingClientRect().left - p.getBoundingClientRect().left;
			var bord = parseFloat(getComputedStyle(p).paddingLeft) || 0;
			if (ecart < bord || ecart + carte.offsetWidth > p.clientWidth) {
				p.scrollTo({ left: p.scrollLeft + ecart - bord, behavior: doux() });
			}
		}

		/* Classe posée sur <html> tant qu'au moins une barre de nuancier est à l'écran (lue par la règle de la barre collante native). */
		function barreVisible() {
			var visible = Array.prototype.some.call(document.querySelectorAll('[data-qb-nuancier]'), function (r) { return r._qbBarreVisible; });
			document.documentElement.classList.toggle('qb-nu-barre-visible', visible);
		}

		function monter(racine) {
			if (!racine) return;
			var choix = racine.querySelector('[data-qb-nu-choix][aria-checked="true"]') || racine.querySelector('[data-qb-nu-choix]');
			if (choix) choisir(racine, choix, true);
			peindreDefilement(racine);
			/* Observé : le bouton d'ajout lui-même, entièrement à l'écran (pas toute la barre, dont le haut n'a pas de bouton). */
			var ajout = racine.querySelector('[data-qb-nu-ajout]');
			if (ajout && 'IntersectionObserver' in window && !racine._qbObs) {
				racine._qbObs = new IntersectionObserver(function (entrees) {
					racine._qbBarreVisible = entrees[entrees.length - 1].isIntersecting;
					barreVisible();
				}, { threshold: 1 });
				racine._qbObs.observe(ajout);
			}
		}

		/* Éditeur de thème : section retirée ou rechargée, l'observateur est coupé et la barre collante native rendue. */
		document.addEventListener('shopify:section:unload', function (event) {
			var racine = event.target.querySelector('[data-qb-nuancier]');
			if (!racine || !racine._qbObs) return;
			racine._qbObs.disconnect();
			racine._qbObs = null;
			racine._qbBarreVisible = false;
			barreVisible();
		});

		document.addEventListener('click', function (event) {
			var cible = event.target;
			var racine = racineDe(cible);
			if (!racine) return;

			var choix = cible.closest('[data-qb-nu-choix]');
			if (choix) {
				choisir(racine, choix, false);
				montrer(racine, choix.closest('[data-qb-nu-groupe]'));
				return;
			}

			var voisine = cible.closest('[data-qb-nu-voisine]');
			if (voisine) {
				var carte = racine.querySelector('[data-qb-nu-choix][data-id="' + voisine.getAttribute('data-qb-nu-voisine') + '"]');
				if (!carte) return;
				if (carte.closest('[data-qb-nu-groupe]').hidden) {
					var toutes = racine.querySelector('[data-qb-nu-filtre=""]');
					if (toutes) toutes.click();
				}
				choisir(racine, carte, false);
				montrer(racine, carte.closest('[data-qb-nu-groupe]'));
				racine.querySelector('[data-qb-nu-ajout]').focus();
				return;
			}

			var filtre = cible.closest('[data-qb-nu-filtre]');
			if (filtre) {
				var g = filtre.getAttribute('data-qb-nu-filtre');
				racine.querySelectorAll('[data-qb-nu-filtre]').forEach(function (f) {
					f.setAttribute('aria-pressed', f === filtre ? 'true' : 'false');
				});
				racine.querySelectorAll('[data-qb-nu-groupe]').forEach(function (c) {
					c.hidden = g !== '' && c.getAttribute('data-qb-nu-groupe') !== g;
				});
				piste(racine).scrollLeft = 0;
				peindreDefilement(racine);
				tabulation(racine);
				return;
			}

			var pas = cible.closest('[data-qb-nu-pas]');
			if (pas && pas.getAttribute('aria-disabled') !== 'true') {
				var p = piste(racine);
				p.scrollBy({ left: Number(pas.getAttribute('data-qb-nu-pas')) * p.clientWidth, behavior: doux() });
			}
		});

		/* Flèches : carte précédente ou suivante parmi les visibles (en boucle), Début et Fin : extrémités. La carte atteinte est choisie (motif radiogroup). */
		document.addEventListener('keydown', function (event) {
			var choix = event.target.closest && event.target.closest('[data-qb-nu-choix]');
			if (!choix || event.altKey || event.ctrlKey || event.metaKey) return;
			var racine = racineDe(choix);
			var visibles = cartesVisibles(racine);
			var i = visibles.indexOf(choix);
			var n = visibles.length;
			var cible = null;
			if (event.key === 'ArrowRight' || event.key === 'ArrowDown') cible = visibles[(i + 1) % n];
			else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') cible = visibles[(i - 1 + n) % n];
			else if (event.key === 'Home') cible = visibles[0];
			else if (event.key === 'End') cible = visibles[n - 1];
			if (!cible) return;
			event.preventDefault();
			choisir(racine, cible, true);
			montrer(racine, cible.closest('[data-qb-nu-groupe]'));
			cible.focus({ preventScroll: true });
			/* La fiche (galerie, prix, blocs QB) ne suit qu'après une pause : une flèche maintenue ne change pas la variante trente fois par seconde. */
			clearTimeout(racine._qbSynchro);
			racine._qbSynchro = setTimeout(function () { synchroniserFiche(racine, cible.getAttribute('data-valeur')); }, 250);
		});

		document.addEventListener('submit', function (event) {
			var form = event.target.closest && event.target.closest('[data-qb-nu-form]');
			var core = window.themeCore;
			if (!form || !core || !core.CartApi) return;
			event.preventDefault();
			var racine = racineDe(form);
			var bouton = form.querySelector('[data-qb-nu-ajout]');
			var erreur = racine.querySelector('[data-qb-nu-erreur]');
			var id = Number(form.querySelector('[data-qb-nu-id]').value);
			var nomEnvoye = bouton.getAttribute('data-qb-nu-nom') || racine.querySelector('[data-qb-nu-b-nom]').textContent;
			if (bouton.getAttribute('aria-busy') === 'true') return;
			bouton.setAttribute('aria-busy', 'true');
			erreur.textContent = '';
			/* Élision devant voyelle : « Ajout d’Ebène… », « Ajout de Limba… ». */
			var ajoutDe = 'Ajout ' + (/^[aeiouyàâäéèêëîïôöûü]/i.test(nomEnvoye) ? 'd’' : 'de ') + nomEnvoye;
			var libEnvoi = bouton.querySelector('[data-qb-nu-b-lib]');
			if (libEnvoi) libEnvoi.textContent = ajoutDe + '…';
			bouton.disabled = true;
			core.CartApi.makeRequest(core.CartApi.actions.ADD_TO_CART, { id: id, quantity: 1 })
				.then(function () {
					var courant = form.querySelector('[data-qb-nu-id]').value;
					if (Number(courant) === id) {
						var lib = bouton.querySelector('[data-qb-nu-b-lib]');
						var ok = racine.querySelector('[data-qb-nu-ok]').content.firstElementChild.cloneNode(true);
						if (lib) {
							lib.replaceChildren(ok);
							clearTimeout(bouton._qbOk);
							bouton._qbOk = setTimeout(function () {
								lib.textContent = 'Ajouter ' + nomEnvoye;
							}, OK_MS);
						}
					}
					racine.querySelector('[data-qb-nu-annonce]').textContent = nomEnvoye + ' ajoutée au panier';
					/* L'ajout a réussi : un échec du rafraîchissement du panier n'est pas une erreur d'ajout. */
					core.CartApi.makeRequest(core.CartApi.actions.GET_CART).catch(function () {});
				})
				.catch(function (e) {
					var detail = e && typeof e.description === 'string' ? e.description : '';
					erreur.textContent = detail ? nomEnvoye + ' : ' + detail : ajoutDe + ' impossible pour le moment. Réessayez.';
					var lib = bouton.querySelector('[data-qb-nu-b-lib]');
					if (lib && Number(form.querySelector('[data-qb-nu-id]').value) === id) lib.textContent = 'Ajouter ' + nomEnvoye;
				})
				.finally(function () {
					bouton.removeAttribute('aria-busy');
					bouton.disabled = bouton._qbDispo === false;
				});
		});

		document.addEventListener('scroll', function (event) {
			var cible = event.target;
			if (cible && cible.matches && cible.matches('[data-qb-nu-piste]')) peindreDefilement(racineDe(cible));
		}, { capture: true, passive: true });

		document.addEventListener('product:variant:change', function (event) {
			var id = event.detail;
			if (!id) return;
			document.querySelectorAll('[data-qb-nuancier]').forEach(function (racine) {
				var table = variantes(racine);
				if (table && table[id]) dispoCartes(racine, table[id][4]);
				var choix = racine.querySelector('[data-qb-nu-choix][data-id="' + id + '"]');
				var v = null;
				if (!choix) {
					var ligne = variantes(racine) && variantes(racine)[id];
					if (!ligne) return;
					v = { id: id, dispo: ligne[1], prix: ligne[2], nom: ligne[3] };
					choix = Array.prototype.find.call(racine.querySelectorAll('[data-qb-nu-choix]'), function (c) {
						return c.getAttribute('data-valeur') === ligne[0];
					});
					if (!choix) return;
				} else if (choix.getAttribute('aria-checked') === 'true' && racine.querySelector('[data-qb-nu-id]').value === String(id)) {
					return;
				}
				choisir(racine, choix, true, v);
				var carte = choix.closest('[data-qb-nu-groupe]');
				if (carte.hidden) {
					var toutes = racine.querySelector('[data-qb-nu-filtre=""]');
					if (toutes) toutes.click();
				}
				montrer(racine, carte);
			});
		});

		document.addEventListener('shopify:section:load', function (event) {
			monter(event.target.querySelector('[data-qb-nuancier]'));
		});

		/*
			Écouteur window unique et global : il repeint toutes les sections présentes,
			sans référence gardée vers une section, donc rien à retirer au déchargement.
		*/
		var attente;
		window.addEventListener('resize', function () {
			cancelAnimationFrame(attente);
			attente = requestAnimationFrame(function () {
				document.querySelectorAll('[data-qb-nuancier]').forEach(peindreDefilement);
			});
		});

		window.__qbNuancier = { monter: monter };
	}

	document.querySelectorAll('[data-qb-nuancier]').forEach(window.__qbNuancier.monter);
})();
